import { memo, FC, Dispatch, SetStateAction, useMemo } from 'react'
import { Flex, FlexProps, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'

import { RoleFilterKeyString } from 'Attendances/types'
import { RefreshButton } from 'components'
import { ROLE_INITIAL_FILTER } from 'Attendances/constants/pages/roles'
import { getRoleFilterFeedbacks } from 'Attendances/utils/getRoleFilterFeedbacks'

type Props = FlexProps & {
  tagBg?: string
  roleFilter: RoleFilterKeyString
  setRoleFilter: Dispatch<SetStateAction<RoleFilterKeyString>>
}

const RoleFilterTags: FC<Props> = ({ tagBg = 'bgContent', roleFilter, setRoleFilter, ...flexProps }) => {
  const filtersWithValue = useMemo(() => {
    return Object.entries(roleFilter).filter(([key]) => {
      return roleFilter[key] !== ROLE_INITIAL_FILTER[key]
    })
  }, [roleFilter])

  function resetFilterByKey(key: string) {
    setRoleFilter({ ...roleFilter, [key]: ROLE_INITIAL_FILTER[key] })
  }

  function resetAllFilters() {
    setRoleFilter(ROLE_INITIAL_FILTER)
  }

  function setFilterFeedbackInTagByKey(key: string, value: string) {
    const filterTagFeedbacks: RoleFilterKeyString = getRoleFilterFeedbacks(value)
    return filterTagFeedbacks[key]
  }

  if (filtersWithValue.length === 0) return null

  return (
    <Flex align="center" flexWrap="wrap" gap={2} {...flexProps}>
      {filtersWithValue.map(([key, value]) => (
        <Tag bg={tagBg} key={key} variant="filter-tags">
          <TagLabel>{setFilterFeedbackInTagByKey(key, value)}</TagLabel>
          <TagCloseButton onClick={() => resetFilterByKey(key)} />
        </Tag>
      ))}

      <RefreshButton onClick={resetAllFilters}>Limpar filtros</RefreshButton>
    </Flex>
  )
}

export default memo(RoleFilterTags)
